// extracted by mini-css-extract-plugin
export default {"productHomePageWrapper":"ProductHomePage_productHomePageWrapper__h2lW0","productHomePage":"ProductHomePage_productHomePage__BnBFF"};